export default {
  'ROBOT:EXCEPTION':
    'Uh oh! Mohon maaf ya sepertinya terjadi kesalahan.. Silahkan coba lagi.',
  'ROBOT:NOANSWER': 'Maaf, Saya kurang paham. Bisa Anda ulangi lagi?',
  'ROBOT:SUGGEST': 'Saya kira Anda ingin mengatakan:',
  'LOGIN:SUCCESS': 'Wahh! Kakak sudah berhasil login di Lazada',
  'KNOWLEDGE:GOOD': 'Ada lagi yang bisa saya bantu?',
  'KNOWLEDGE:BAD':
    'Mohon maaf ya jika jawaban yang CLEO berikan kurang membantu. CLEO sarankan kamu untuk langsung chat dengan teman CS CLEO ya, kamu bisa klik tombol "Live Agent" dibawah ini',
  'SHIPPING:ADDRESS': 'Alamat pengiriman',
  'ROBOT:RECOMMEND':
    'Apakah Anda ingin masih ingin mengetahui informasi mengenai hal berikut:',
  'ROBOT:RECOMMEND:RELATED': 'Hai, mungkin ini yang ingin kamu tanyakan:',
  'TRACKING:DETAIL': 'Rincian status',
  'ORDER:STATUS': 'Status pesanan',
  'CANCEL:ITEM': 'Pembatalan pesanan',
  'BUTTON:MORE': 'lihat selengkapnya',
  'SHOW:ALLORDERS': 'Tampilkan seluruh pesanan saya',
  'ROBOT:WELCOME': '..atau jawab pertanyaan yang Anda punya mengenai Lazada.',
  'ROBOT:LIVEAGENT': 'Saya ingin chat langsung dengan Agent',
  'PAGE:404': 'Maaf, halaman yang Anda cari tidak tersedia.',
  'WORD:ITEM': 'Item',
  'FEEDBACK:QUESTION': 'Apakah artikel ini membantu?',
  'FEEDBACK:THANKS': 'Terima kasih!',
  'LIVE:AGENT': 'live agent',
  'BUTTON:LOGIN': 'Login',
  'BUTTON:SEND': 'Kirim',
  openOrder: n => `Kakak punya ${n} pesanan yang masih berjalan`,
  openOrderToCancel: n => `Kakak punya ${n} pesanan yang masih berjalan`,
  indexOrder: (o, n) => `Pesanan ${o} dari ${n}`,
  packageDetail: (o, n) => `Rincian untuk pesanan ${o} dengan ${n} produk`,
  orderDetail: (o, p, n) =>
    `Nomor pesanan ${o} dipesan pada ${p} terdiri dari ${n}`,
  packageOrder: (p, n) => `Pesanan ${p} dari ${n}`,
  tracking: (p, n) =>
    `Berikut rincian pesanan untuk <span class="bold">Pesanan ${p}</span> dari nomor pesanan <span class="bold">${n}</span>`,
};



// WEBPACK FOOTER //
// ./src/bu/pc/locales/id-id.js